import { render, staticRenderFns } from "./Marketpromotion.vue?vue&type=template&id=ba7a83c6&scoped=true&"
import script from "./Marketpromotion.vue?vue&type=script&lang=js&"
export * from "./Marketpromotion.vue?vue&type=script&lang=js&"
import style0 from "./Marketpromotion.vue?vue&type=style&index=0&id=ba7a83c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7a83c6",
  null
  
)

export default component.exports